import { useHistory } from '../../hocs/content/useVideos'
import { useI18N } from '../../libraries/i18n/hook'
import PageHeading from '../components/layout/PageHeading'
import VideosGrid from '../containers/content/videos/Grid'

const UserHistory = () => {
  const { t } = useI18N()
  return (
    <>
      <PageHeading>{t('videos.history')}</PageHeading>
      <VideosGrid queryFn={() => useHistory()} />
    </>
  )
}

export default UserHistory
